module.exports = __webpack_public_path__ + "img/UYU.375e2a34.svg";